import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  ITicket,
  ITicketListRequest,
  ITicketCreateRequest,
  ITicketUpdateRequest,
  TicketState,
} from "@/types/ticket";
import CustomRequest from "../customRequest";

const actions: ActionTree<TicketState, RootState> = {
  async get({ commit }, ticket_id: number) {
    await CustomRequest.get<IPagination<ITicket>>({
      uri: `/ticket/${ticket_id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }, member_id: number) {
    await CustomRequest.get<IPagination<ITicket>>({
      uri: `/member/${member_id}/ticket/`,
      commit,
      target: "pagination",
    });
  },

  async salesGet({ commit }, ticket_id: number) {
    await CustomRequest.get<IPagination<ITicket>>({
      uri: `/sales/ticket/${ticket_id}`,
      commit,
      target: "single",
    });
  },

  async salesGetList({ commit }, params: ITicketListRequest) {
    await CustomRequest.get<IPagination<ITicket>>({
      uri: `/sales/ticket/`,
      params,
      commit,
      target: "pagination",
    });
  },

  async salesUpdate(
    { commit },
    datas: { ticket_id: number; params: ITicketUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IPagination<ITicket>>({
      uri: `/sales/ticket/${datas.ticket_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesCreate({ commit }, params: ITicketCreateRequest) {
    const { error } = await CustomRequest.post<IPagination<ITicket>>({
      uri: `/sales/ticket`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async salesDelete({ commit }, ticket_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/ticket/${ticket_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
